import { CustomActionType, Res, TicketLineDTO } from 'core/api';
import { Result } from 'core/infrastructure';
import applyOffer from './applyOffer';
import setPriceList from './setPriceList';
import { doAdvancedDirectPayment } from './doAdvancedDirectPayment';
import { executeExternalAction, ExecuteExternalActionParams } from './executeExternalAction';
import applyNamedDiscount from './applyNamedDiscount';
import { Command } from 'pos/common';
import { RestaurantFacade } from 'pos/facades';
import { ExternalActionFlow } from './ExternalActionFlow';
import { Message } from 'core/ui-next/modal';

// OJO: No lleva permiso porque se valida un permiso específico para cada acción a ejecutar
type Args = {
	actionId: string,
	buttonText: string,
	introducedValue: Nullable<number>,
	selectedLine: Nullable<TicketLineDTO>,
	imageSrc: string,
	externalActionArgs: ExecuteExternalActionParams['args']
}

declare global {
	interface CommandType {
		runDirectAction: (args: Args) => Promise<Result<ExternalActionFlow>>
	}
}

Command.register('runDirectAction', 'NO_PRECONDITION', async ({ actionId, buttonText, introducedValue, selectedLine, imageSrc, externalActionArgs }: Args): Promise<Result<ExternalActionFlow>> => {

	const command = await RestaurantFacade.getCustomActionButtonCommand(actionId);
	if (!command.HasPermission) {
		await Message.show(Res.Msg.MSG_INVALID_PERMISSION_TO_EXECUTE_ACTION(buttonText));
		return Result.error();
	}

	switch (command.ActionType) {
		case CustomActionType.DirectPayment:
			command.IsAdvancedDirectPayment
				? await doAdvancedDirectPayment({ methodId: command.ArgumentId!, introducedAmount: introducedValue, imageSrc })
				: await Command.execute('doDirectPayment', { methodId: command.ArgumentId!, amount: introducedValue });
			return Result.ok('none');
		case CustomActionType.NamedDiscount:
			await applyNamedDiscount({ discountId: command.ArgumentId!, line: selectedLine });
			return Result.ok('none');
		case CustomActionType.Offer:
			await applyOffer({ offerId: command.ArgumentId! });
			return Result.ok('none');
		case CustomActionType.PriceList:
			await setPriceList({ priceListId: command.ArgumentId! });
			return Result.ok('none');
		case CustomActionType.External: {
			return await executeExternalAction({
				title: buttonText,
				imageSrc,
				action: command.CommandValue,
				showUrlInEmbeddedViewer: command.ShowUrlInEmbeddedViewer,
				args: externalActionArgs
			});
		}
		default:
			throw new Error(`Unsopported Action Type ${CustomActionType.toString(command.ActionType)}`);
	}
});